<template>
  <div class="A06_gsfc aboutchild">
    <div class="aboutchildbox">
      <div class="title" id="lc">
        <div class="txtStyle">企业文化</div>
        <div class="bj"></div>
      </div>
      <div class="zlList">
        <div
          class="imgcon"
          v-for="item in list"
          :key="item.index"
          @click="playimg(item.index)"
        >
          <img :src="item.url" alt="" />
          <p>{{ item.text }}</p>
        </div>
      </div>
      <div class="zlpage">
        <el-pagination
          id="FY"
          @current-change="pagefun"
          background
          layout="prev, pager, next"
          :total="pages.total"
          :current-page="pages.current"
          :page-size="pages.size"
        >
        </el-pagination>
      </div>
      <!-- 轮播图 -->
      <div class="imgs1" id="out" v-if="show" @click="hiddenImgs">
        <div class="imgs2">
          <div class="lunBo">
            <el-carousel
              indicator-position="outside"
              height="1250px"
              :autoplay="false"
              :initial-index="showindex"
              id="LB"
            >
              <el-carousel-item v-for="item in list" :key="item.index">
                <div class="pictureLB" id="in" @click="hiddenImgs">
                  <img :src="item.url" alt="" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "A02_qywh",
  data() {
    return {
      pages: {
        current: 1,
        total: 0, //未知
        size: 16,
      },
      show: false,
      showindex: 0,
      allp: 24,
      alist: [],
      list: [],
      listname: [
        "公司前台",
        "党员活动室",
        "研究中心",
        "研究中心",
        "研究中心",
        "研究中心",
        "研究中心",
        "研究中心",
        "金鹰培训",
        "金鹰培训",
        "法务合规",
        "市场服务部",
        "市场服务部",
        "市场服务部",
        "企业活动",
        "企业活动",
        "企业活动",
        "企业活动",
        "企业活动",
        "团队活动",
        "团队活动",
        "团队活动",
        "团队活动",
        "社会责任",
      ],
    };
  },
  mounted() {
    this.getlist();
  },
  methods: {
    getlist: function () {
      for (var i = 1; i < this.allp; i++) {
        var obj = {
          index: i,
          text: this.listname[i],
          url:
            "https://dexun-www-news.oss-cn-shenzhen.aliyuncs.com/gsfc" +
            (i + 1) +
            ".jpg",
        };
        this.alist.push(obj);
      }
      this.pages.total = this.allp;
      this.pagefun(1);
    },
    pagefun: function (p) {
      var ns = (p - 1) * 16;
      var nd = p * 16 - 1;
      this.list = [];
      var narr = JSON.parse(JSON.stringify(this.alist));
      var ins = 0;
      for (var x in narr) {
        var obj = narr[x];
        if (obj.index >= ns && obj.index <= nd) {
          obj.index = ins;
          this.list.push(obj);
          ins++;
        }
      }
      //console.log(this.list);
    },
    toDetail: function () {
      this.$router.push({ path: "/B10_xgsm" });
    },
    playimg: function (n) {
      this.show = true;
      this.showindex = n;
      console.log(this.showindex);
    },
    hiddenImgs: function (event) {
      event.stopPropagation();
      var target = event.currentTarget;
      if (target.id == "out") {
        this.show = false;
      } else {
        this.show = true;
      }
    },
  },
};
</script>
<style scoped>
.aboutchild {
  overflow: hidden;
  opacity: 1;
  background: #fff;
}
.aboutchildbox {
  width: 1236px;
  opacity: 1;
  overflow: hidden;
  margin-left: 200px;
}

.zlList,
.zlpage {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
}

.zlpage {
  margin-top: 15px;
}
.imgcon {
  width: 293px;
  opacity: 1;
  float: left;
  margin-left: 16px;
  margin-bottom: 16px;
}
.imgcon p {
  float: left;
  width: 100%;
  height: 28px;
  font-size: 20px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  text-align: center;
}
.imgcon img {
  float: left;
  display: inline-block;
  margin-bottom: 10px;
  width: 293px;
  height: 187px;
}

/* 轮播图 */
#LB /deep/ .el-carousel__container .el-carousel__arrow {
  top: 40%;
  width: 60px;
  height: 60px;
}
#LB /deep/ .el-carousel__container .el-carousel__arrow i {
  font-size: 32px;
}
#LB /deep/ .el-carousel__container .el-carousel__arrow--right {
  top: 40%;
  right: 350px;
}
#LB /deep/ .el-carousel__container .el-carousel__arrow--left {
  top: 40%;
  left: 350px;
}
/* 分页 */
#FY /deep/ .el-pager .number {
  border-radius: 4px;
}
#FY /deep/ .el-pager .active {
  background-color: #e7413b;
}
#FY /deep/ .el-pager .number:not(.active):hover {
  color: #666;
}
.imgs1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.imgs2 {
  position: relative;
}
.lunBo {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 1262px;
  background: rgba(0, 0, 0, 0.39);
  opacity: 1;
}
.pictureLB {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 862px;
  height: 572px;
  opacity: 1;
  border-radius: 6px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: -400px 0 0 -431px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pictureLB img {
  width: 100%;
}
.title {
  position: relative;
  width: 710px;
  height: 56px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 56px;
  color: #1d1d1d;
  font-size: 40px;
  text-align: center;
  line-height: 56px;
  margin: 0 auto;
  margin-bottom: 30px;
}
.txtStyle {
  line-height: 56px;
}
.bj {
  position: absolute;
  top: 20px;
  /* left: 598px; */
  width: 710px;
  height: 16px;
  background: url("../../common/images/investCenter/textBj.png") no-repeat;
}
</style>


// WEBPACK FOOTER //
// src/components/aboutS/A02_qywh.vue